'use client';

import React from 'react';
import { BookOpen, ShieldCheck, BarChart2 } from 'lucide-react';

const topicStats = [
  {
    label: 'Strategy Fundamentals',
    icon: <BookOpen size={14} />,
    completed: 2,
    total: 4,
    color: 'bg-primary',
    textColor: 'text-primary',
  },
  {
    label: 'Risk Management',
    icon: <ShieldCheck size={14} />,
    completed: 1,
    total: 4,
    color: 'bg-warning',
    textColor: 'text-warning',
  },
  {
    label: 'Chart Patterns',
    icon: <BarChart2 size={14} />,
    completed: 1,
    total: 4,
    color: 'bg-neutral-500',
    textColor: 'text-[#6366F1]',
  },
];

export default function OverallProgress() {
  const totalCompleted = topicStats?.reduce((s, t) => s + t?.completed, 0);
  const totalModules = topicStats?.reduce((s, t) => s + t?.total, 0);
  const overallPct = Math.round((totalCompleted / totalModules) * 100);

  return (
    <div className="bg-card border border-border rounded-xl p-5 card-glow-primary">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5">
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-widest font-medium mb-0.5">
            Overall Progress
          </p>
          <p className="text-2xl font-bold text-foreground font-mono-nums">
            {overallPct}%
            <span className="text-sm font-normal text-muted-foreground ml-2">
              {totalCompleted} of {totalModules} modules
            </span>
          </p>
        </div>
        <div className="text-right hidden sm:block">
          <p className="text-xs text-muted-foreground">Est. time remaining</p>
          <p className="text-sm font-semibold text-foreground">~4h 20m</p>
        </div>
      </div>
      {/* Master progress bar */}
      <div className="w-full h-2 bg-muted rounded-full mb-5 overflow-hidden">
        <div
          className="h-full bg-primary rounded-full progress-bar-inner"
          style={{ width: `${overallPct}%` }}
        />
      </div>
      {/* Per-topic breakdown */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {topicStats?.map((t) => {
          const pct = Math.round((t?.completed / t?.total) * 100);
          return (
            <div key={t?.label} className="space-y-1.5">
              <div className="flex items-center justify-between">
                <div className={`flex items-center gap-1.5 ${t?.textColor}`}>
                  {t?.icon}
                  <span className="text-xs font-medium text-foreground">{t?.label}</span>
                </div>
                <span className="text-xs font-mono-nums text-muted-foreground">
                  {t?.completed}/{t?.total}
                </span>
              </div>
              <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full ${t?.color} rounded-full progress-bar-inner`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
